export default {
    siteMetadata: {
        title: 'NobleWills',
        description: 'NobleWills: 輕鬆訂立平安紙',
        keywords: '香港平安紙, 遺產計劃, 監護人, 平安紙執行人',
    },
};
